
const BASE_URL = "https://assocham.org";

export async function fetchTicker() {
  const res = await fetch(`${BASE_URL}/api/get_highlights.php`);

  if (!res.ok) {
    throw new Error(`Ticker API failed: ${res.status}`);
  }

  const json = await res.json();

  if (!json.status) {
    throw new Error("Ticker API returned an error");
  }

  // [{ id, text, link, isPdf }]
  return json.data;
}